import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import I10n from "../features/i10n";
import InformationIcon from "../atoms/information-icon";
import { front_base_url } from "../constants";
import Tooltip from "./documentation/tootip";
import { PRIMARY_COLOR } from "../color-constants";

const ConfigurationCountryWrapper = styled.div`
  padding-left: 10px;
  display: flex;
  height: 50px;
  align-items: center;
`;

const Flag = styled.img`
  height: 30px;
  width: 30px;

  @media (max-width: 400px) {
    height: 20px;
    width: 20px;
  }
`;

const FlagText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  margin-left: 5px;
`;

const CountryIconWrapper = styled.div`
  color: #a0a4a8;
  margin-left: 5px;
`;

const CountryHint = styled.div`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  padding: 10px;
  min-width: 200px;
  font-size: 14px;
`;

class CountryConfiguration extends React.Component {
  static propTypes = {
    country: PropTypes.string,
  };

  render() {
    return (
      <ConfigurationCountryWrapper>
        <Flag
          src={`${front_base_url}/flags/${this.props.country || "WW"}.svg`}
        ></Flag>
        <FlagText>{`${this.props.country}`}</FlagText>

        <Tooltip
          data-clickable
          toggleElement={
            <CountryIconWrapper slot="trigger">
              <InformationIcon size="small"></InformationIcon>
            </CountryIconWrapper>
          }
          containerElement={
            <CountryHint>
              {I10n.getAndReplace(
                "screen.start_configuration_screen.country_hint",
                this.props.country || "WW"
              )}
            </CountryHint>
          }
          allowTop={true}
        ></Tooltip>
      </ConfigurationCountryWrapper>
    );
  }
}

export default CountryConfiguration;
